import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/batch/batchForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const BatchFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

BatchFormPage.propTypes = {};

export default BatchFormPage;
